import { Collection } from '../types/collection';
import { is } from '../util/is';
import { reduce } from '../collections/reduce';

export type TMergeFn = (
  k: string | number,
  a: Collection<unknown>,
  b: Collection<unknown>
) => Collection<unknown> | undefined;

export function _merge(fn: TMergeFn, dest: Collection<unknown>, source: Collection<unknown>): Collection<unknown> {
  return reduce(
    (acc, v, k) => {
      if ((is(Object, v) && is(Object, acc[k])) || (is(Array, v) && is(Array, acc[k]))) {
        let newVal: Collection<unknown> | undefined = is(Function, fn)
          ? fn(k, acc[k], v as Record<string, unknown>)
          : undefined;

        if (undefined === newVal) {
          newVal = v as Record<string, unknown>;
        }

        _merge(fn, acc[k], newVal!);
      } else {
        acc[k] = v as Record<string, unknown>;
      }
      return acc;
    },
    dest as Record<string, Collection<unknown>>,
    source
  );
}
